export const UserEnum = {
    USERINFO: 'engineer-user-info',
};
